import { selector } from "recoil";

import { globalSearchAtom } from "../atoms";

export const isGlobalSearchActiveSelector = selector<boolean>({
  key: "isGlobalSearchActiveSelector",
  get: ({ get }) => {
    const globalSearch = get(globalSearchAtom);
    return Boolean(globalSearch);
  },
});
